export const iconFontAwesomeFruitsVegetablesLemon = (
	<i className="fa-solid fa-lemon"></i>
);
